"use client";

// 보기를 선택하는 즉시(제출 버튼 없이) 부모 폼을 제출한다. 선택 = 제출이므로
// 문제별 응답은 "그만두기"를 누르지 않아도 선택한 순간 서버에 기록된다.
export function AutoSubmitChoices({ choices }: { choices: string[] }) {
  return (
    <>
      {choices.map((choice, i) => (
        <label
          key={i}
          className="flex cursor-pointer items-center gap-3 rounded-lg border border-foreground/10 p-4 text-left transition hover:border-foreground/30 has-[:checked]:border-foreground has-[:checked]:bg-foreground/[0.04]"
        >
          <input
            type="radio"
            name="selectedIndex"
            value={i}
            required
            className="accent-foreground"
            onChange={(e) => e.currentTarget.form?.requestSubmit()}
          />
          {choice}
        </label>
      ))}
    </>
  );
}
